import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalTab, setModalTab] = useState<'privacy' | 'terms'>('privacy');
  const openLegal = (tab: 'privacy' | 'terms') => (e: React.MouseEvent) => {
    e.preventDefault();
    setModalTab(tab);
    setIsModalOpen(true);
  };
  return <>
      <footer className="bg-stone-900 text-stone-500 py-12 text-center text-sm border-t border-stone-800" data-id="element-1">
        <div className="max-w-6xl mx-auto px-4 flex flex-col items-center" data-id="element-2">
          <p className="mb-6" data-id="element-3">
            © 2024 Reset Hormonal. Todos los derechos reservados.
          </p>

          <div className="flex flex-wrap justify-center gap-6 mb-6" data-id="element-4">
            <a href="#" onClick={openLegal('privacy')} className="hover:text-rose-400 transition-colors underline decoration-stone-700 underline-offset-4 hover:decoration-rose-400" data-id="element-5">
              Política de Privacidad
            </a>
            <a href="#" onClick={openLegal('terms')} className="hover:text-rose-400 transition-colors underline decoration-stone-700 underline-offset-4 hover:decoration-rose-400" data-id="element-6">
              Términos y Condiciones
            </a>
          </div>

          <p className="text-xs text-stone-600 max-w-md mx-auto" data-id="element-7">
            Este producto no sustituye el consejo médico profesional. Consulte
            siempre a un especialista para temas relacionados con su salud.
          </p>
        </div>
      </footer>

      <LegalModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} initialTab={modalTab} data-id="element-8" />
    </>;
}